(function () {
  'use strict';
  angular.module('benefits')
    .component('familyInfo', {
        bindings: {
          refId: '='
        },
        controller: ['benefitService', function selectMemberController(benefitService) {
          var ctrl = this;
          this.$onInit = function () {
            benefitService.getMembers().then(function (data) {
              ctrl.members =  _.flatten(_.partition(data, function (m) {
                  return _.find(m.policies, (p) => {
                    return p.referenceId == ctrl.refId;
                  });
                }
              ));
              ctrl.members.serviceUnavailable = !data || data.serviceUnavailable;
            });
          };
        }],
        templateUrl: 'js/benefits/familyInfo.html' + appVersion
      }
    );
})();
